import Spinner from './spinner-loader.vue';
import Dots from './dots-loader.vue';
import Bars from './bars-loader.vue';

export default {
  Spinner,
  Dots,
  Bars,
};
